import React from "react"
import { useTranslation } from "react-i18next"
import * as Components from "../components/components"
import { useChangeProperty } from "./hooks/UseChangeProperty"
import { useStoreRechnung } from "../store"

interface AbweichenderZahlungsempfaengerViewProps {
    basePath: string
}

export function AbweichenderZahlungsempfaengerView({ basePath }: AbweichenderZahlungsempfaengerViewProps) {
    const [onChange] = useChangeProperty(basePath)
    const { t } = useTranslation()
    const {
        zahlungsdaten: { abweichenderZahlungsempfaenger },
    } = useStoreRechnung("zahlungsdaten")

    return (
        <Components.Collapsible title={t("rechnung.zahlungsdaten.abweichenderZahlungsempfaenger.title")} collapsed={true}>
            <Components.FormGroup label={t("rechnung.zahlungsdaten.abweichenderZahlungsempfaenger.name.label")}>
                <Components.TextEdit
                    placeholder={t("rechnung.zahlungsdaten.abweichenderZahlungsempfaenger.name.placeholder")}
                    onChange={onChange("name")}
                    value={abweichenderZahlungsempfaenger?.name}
                />
            </Components.FormGroup>

            <Components.FormGroup label={t("rechnung.zahlungsdaten.abweichenderZahlungsempfaenger.kennung.label")}>
                <Components.TextEdit
                    placeholder={t("rechnung.zahlungsdaten.abweichenderZahlungsempfaenger.kennung.placeholder")}
                    onChange={onChange("kennung")}
                    value={abweichenderZahlungsempfaenger?.kennung}
                />
            </Components.FormGroup>

            <Components.FormGroup label={t("rechnung.zahlungsdaten.abweichenderZahlungsempfaenger.handelsregisterNr.label")}>
                <Components.TextEdit
                    placeholder={t("rechnung.zahlungsdaten.abweichenderZahlungsempfaenger.handelsregisterNr.placeholder")}
                    onChange={onChange("handelsregisterNr")}
                    value={abweichenderZahlungsempfaenger?.handelsregisterNr}
                />
            </Components.FormGroup>
        </Components.Collapsible>
    )
}
